import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useParams, useLocation } from "react-router-dom";
import useApi from "../../hooks/useApi";
import useReload from "../../hooks/useReload";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import TableWidget from "../../widgets/TableWidget";
import FileWidget from "../../widgets/FileWidget";
import useApp from "../../hooks/useApp";
import { Form, InputGroup } from "react-bootstrap";

const AddPolicyItem = (props) => {
  const [dropDowns, setDropDowns] = useState({ policyType: [] });
  const [requirements, setRequirements] = useState([]);
  const [productRequirements, setProductRequirements] = useState([]);
  const [policyTypeRequirements, setPolicyTypeRequirements] = useState([]);
  const [policyItemRequirement, setPolicyItemRequirement] = useState({});
  const [policyItem, setPolicyItem] = useState({});
  const { id } = useParams();
  const policyRef = useRef();
  const productRef = useRef();
  const [showButton, setShowButton] = useState(false);
  const { api, abortSignal, auth } = useApi();
  const { toggleReload } = useReload();
  const { showAlert } = useApp();

  const handleSave = async (e) => {
    e.preventDefault();

    if (!policyItem?.ProductId?.value) {
      showAlert("Please select product", "error");
      productRef.current.focus();
      return;
    }

    const selectTypeRequirements = requirements.filter(
      (element) => element.type === "select"
    );

    const fileTypeRequirements = requirements.filter(
      (element) => element.type === "file"
    );

    try {
      let requirementData = policyItemRequirement;

      selectTypeRequirements.forEach((requirement) => {
        let requirementValue = requirementData[requirement.id]?.value || "";

        requirementData = {
          ...requirementData,
          [requirement.id]: requirementValue,
        };
      });

      //upload the files
      const uploads = [];
      const filesUploaded = [];
      const filesRemoved = [];
      let filesToRemove = [];

      fileTypeRequirements.forEach((requirement) => {
        let files = requirementData[requirement.id];

        if (files) {
          let filesRemoving = [];
          let filesRemovingRemote = [];
          let formData = new FormData();
          for (const [key, value] of Object.entries(files)) {
            if (value.local) {
              formData.append("files", value);
            }

            if (value.delete) {
              filesRemovingRemote.push(
                api.delete(`/files/upload/${value.filename}`)
              );
              filesRemoving.push(value);
            }
          }

          if (filesRemoving.length > 0) {
            filesToRemove.push({ [requirement.id]: filesRemoving });
            filesRemoved.push({ [requirement.id]: filesRemovingRemote });
          }

          let fileCount = 0;
          for (const pair of formData.entries()) {
            fileCount += 1;
          }

          if (fileCount) {
            uploads.push(api.add(`/files/upload`, formData));
            filesUploaded.push(requirement.id);
          }
        }
      });

      if (filesRemoved.length > 0) {
        try {
          filesRemoved.forEach(async (removing) => {
            //const removed = await Promise.all(removing);
            // console.log(removed);
          });

          filesToRemove.forEach((files, index) => {
            for (const [key, value] of Object.entries(files)) {
              //console.log(requirementData[key]);
              requirementData = {
                ...requirementData,
                [key]: [
                  ...requirementData[key].filter((file) => !file.delete == 1),
                ],
              };

              setPolicyItemRequirement((requirement) => {
                return {
                  ...requirement,
                  [key]: [
                    ...requirement[key].filter((file) => !file.delete == 1),
                  ],
                };
              });
            }
          });
        } catch (error) {
          console.error(error);
        }
      }

      const uploaded = await Promise.all(uploads);

      if (uploaded) {
        uploaded.forEach((files, index) => {
          if (files.ok) {
            requirementData = {
              ...requirementData,
              [filesUploaded[index]]: [
                ...requirementData[filesUploaded[index]].filter(
                  (file) => !file.local
                ),
                ...files.data,
              ],
            };
          }
        });
      }

      const data = {
        ...policyItem,
        PolicyTypeId: policyItem?.PolicyTypeId?.value || null,
        CompanyId: policyItem?.CompanyId?.value || null,
        ProductId: policyItem?.ProductId?.value || null,
        policyRequirement: JSON.stringify(requirementData),
        PolicyId: id,
      };
      const response = await api.add("/policies/policy-items", data);
      if (response.ok) {
        setProductRequirements([]);
        setPolicyTypeRequirements([]);
        setRequirements([]);
        setPolicyItemRequirement({});
        setPolicyItem({});
        setShowButton(false);
        toggleReload();
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getDropDowns = async (models) => {
    try {
      const { data } = await api.list(`/dropdowns`, models);
      return data;
    } catch (error) {
      console.error(error);
    }
  };

  const handlePolicyTypeChange = async (selectedOption) => {
    const id = selectedOption.value;
    setPolicyItem({
      ...policyItem,
      PolicyTypeId: selectedOption,
      ProductId: "",
    });
    try {
      const { data } = await api.list(
        `/policies/policy-types/${id}/requirements`
      );
      setPolicyTypeRequirements(
        data.map((prod) => {
          return {
            ...prod,
            sequence: prod?.PolicyTypeRequirement?.sequence || 10,
          };
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  const handleCompanyChange = async (selectedOption) => {
    const id = selectedOption.value;
    setPolicyItem({
      ...policyItem,
      CompanyId: selectedOption,
    });
  };

  const handleProductChange = async (selectedOption) => {
    const id = selectedOption.value;
    setPolicyItem({
      ...policyItem,
      ProductId: selectedOption,
    });
    try {
      const { data } = await api.list(`/products/${id}/requirements`);
      setProductRequirements(
        data.map((prod) => {
          return {
            ...prod,
            sequence: prod?.ProductRequirement?.sequence || 10,
          };
        })
      );
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const productDropDown = async () => {
      try {
        const data = await getDropDowns([
          {
            product: {
              PolicyTypeId: policyItem.PolicyTypeId.value,
            },
          },
        ]);
        setDropDowns({ ...dropDowns, ...data });
      } catch (error) {}
    };
    if (policyItem.PolicyTypeId) {
      productDropDown();
      setShowButton(true);
    }
  }, [policyItem.PolicyTypeId]);

  useEffect(() => {
    let removeDups = [...policyTypeRequirements, ...productRequirements];
    removeDups = removeDups.filter(
      (value, index, self) =>
        index ===
        self.findIndex((t) => t.place === value.place && t.name === value.name)
    );

    removeDups
      .filter((req) => req.type === "select")
      .forEach((element) => {
        const options = element.options;
        let defaultOption;
        element.options.split(",").forEach((option) => {
          if (option.charAt(0) === "*") {
            defaultOption = {
              value: option.slice(1),
              label: option.slice(1),
            };

            setPolicyItemRequirement({
              ...policyItemRequirement,
              [element.id]: defaultOption,
            });
          }
        });
      });

    //sort based on sequence
    removeDups.sort(function (a, b) {
      return a.sequence - b.sequence;
    });
    setRequirements([...removeDups]);
  }, [productRequirements, policyTypeRequirements]);

  useEffect(() => {
    const callDropDown = async () => {
      const data = await getDropDowns(["policyType", "company"]);
      setDropDowns(data);
    };
    callDropDown();
  }, [auth]);

  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true);
  };

  return (
    <>
      <Button
        onClick={handleShow}
        variant="info"
        className="hstack gap-2 mb-3 me-2"
      >
        <i className="demo-psi-add fs-4"></i>
        <span className="vr"></span>
        Add Policy Item
      </Button>
      <Link
        to="/policies"
        className="btn btn-outline-primary hstack gap-2 mb-3"
      >
        <i className="demo-psi-file fs-4"></i>
        <span className="vr"></span>
        Policies
      </Link>

      <Modal
        show={show}
        onHide={handleClose}
        backdrop="static"
        keyboard={false}
        size="lg"
      >
        <form onSubmit={handleSave} autoComplete="off">
          <Modal.Header closeButton>
            <Modal.Title>Add Individual Policy Item</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="row mb-3">
              <label
                htmlFor="title"
                className="col-sm-3 col-form-label text-primary"
              >
                Title
              </label>
              <div className="col-sm-9">
                <input
                  id="title"
                  className="form-control border-primary"
                  onChange={(e) =>
                    setPolicyItem({
                      ...policyItem,
                      title: e.target.value,
                    })
                  }
                  value={policyItem?.title || ""}
                  autoFocus
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="policy-type"
                className="col-sm-3 col-form-label text-primary"
              >
                Policy Type
              </label>
              <div className="col-sm-9">
                <Select
                  id="policy-type"
                  ref={policyRef}
                  options={
                    dropDowns && dropDowns["policyType"]
                      ? dropDowns["policyType"]
                      : []
                  }
                  onChange={(selectedOption) =>
                    handlePolicyTypeChange(selectedOption)
                  }
                  value={policyItem?.PolicyTypeId || ""}
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="company"
                className="col-sm-3 col-form-label text-primary"
              >
                Underwriting Company
              </label>
              <div className="col-sm-9">
                <Select
                  id="company"
                  options={
                    dropDowns && dropDowns["company"]
                      ? dropDowns["company"]
                      : []
                  }
                  onChange={(selectedOption) =>
                    handleCompanyChange(selectedOption)
                  }
                  value={policyItem?.CompanyId || ""}
                  required
                />
              </div>
            </div>
            <div className="row mb-3">
              <label
                htmlFor="product"
                className="col-sm-3 col-form-label text-primary"
              >
                Product
              </label>
              <div className="col-sm-9">
                <Select
                  id="product"
                  ref={productRef}
                  options={
                    dropDowns && dropDowns["product"]
                      ? dropDowns["product"]
                      : []
                  }
                  onChange={(selectedOption) =>
                    handleProductChange(selectedOption)
                  }
                  value={policyItem?.ProductId || ""}
                  required
                />
              </div>
            </div>
            <div>
              {requirements && requirements.length > 0 && (
                <h4 className="border-bottom border-3 mt-2">
                  Policy requirements
                </h4>
              )}
              {requirements &&
                requirements.map((element) => {
                  const options = element.options;
                  let defaultOption;
                  if (element.type === "select") {
                    defaultOption = "";
                    element.options.split(",").forEach((option) => {
                      if (option.charAt(0) === "*") {
                        defaultOption = {
                          value: option.slice(1),
                          label: option.slice(1),
                        };
                      }
                    });
                  }
                  return (
                    <div className="row mb-3" key={element.id}>
                      {element.type === "label" ? (
                        <div>
                          <h4>{element?.name}</h4>
                          <span>{element?.options}</span>
                        </div>
                      ) : (
                        <>
                          <label
                            htmlFor={element.id}
                            className="col-sm-3 col-form-label text-primary"
                          >
                            {element.name}
                          </label>
                          <div className="col-sm-9">
                            {element.type === "check" ? (
                              <div className="form-check form-switch">
                                <input
                                  id={element.id}
                                  className="form-check-input mt-2"
                                  type="checkbox"
                                  onChange={(e) =>
                                    setPolicyItemRequirement({
                                      ...policyItemRequirement,
                                      [element.id]: e.target.checked,
                                    })
                                  }
                                />
                              </div>
                            ) : element.type === "date" ? (
                              element.options ? (
                                element.options === "year" ? (
                                  <DatePicker
                                    id={element.id}
                                    className="form-control"
                                    selected={
                                      policyItemRequirement?.[element.id] &&
                                      new Date(
                                        policyItemRequirement?.[element.id]
                                      )
                                    }
                                    showPopperArrow={false}
                                    showYearPicker
                                    dateFormat="yyyy"
                                    onChange={(date) =>
                                      setPolicyItemRequirement({
                                        ...policyItemRequirement,
                                        [element.id]: date,
                                      })
                                    }
                                    isClearable
                                  />
                                ) : element.options === "month" ? (
                                  <DatePicker
                                    id={element.id}
                                    className="form-control"
                                    selected={
                                      policyItemRequirement?.[element.id] &&
                                      new Date(
                                        policyItemRequirement?.[element.id]
                                      )
                                    }
                                    showPopperArrow={false}
                                    showMonthYearPicker
                                    dateFormat="MM/yyyy"
                                    onChange={(date) =>
                                      setPolicyItemRequirement({
                                        ...policyItemRequirement,
                                        [element.id]: date,
                                      })
                                    }
                                    isClearable
                                  />
                                ) : element.options === "time" ? (
                                  <DatePicker
                                    id={element.id}
                                    className="form-control"
                                    selected={
                                      policyItemRequirement?.[element.id] &&
                                      new Date(
                                        policyItemRequirement?.[element.id]
                                      )
                                    }
                                    showPopperArrow={false}
                                    showTimeSelect
                                    showTimeSelectOnly
                                    timeIntervals={15}
                                    timeCaption="Time"
                                    dateFormat="h:mm aa"
                                    onChange={(date) =>
                                      setPolicyItemRequirement({
                                        ...policyItemRequirement,
                                        [element.id]: date,
                                      })
                                    }
                                    isClearable
                                  />
                                ) : (
                                  <DatePicker
                                    id={element.id}
                                    className="form-control"
                                    selected={
                                      policyItemRequirement?.[element.id] &&
                                      new Date(
                                        policyItemRequirement?.[element.id]
                                      )
                                    }
                                    showPopperArrow={false}
                                    dateFormat="dd/MM/yyyy"
                                    onChange={(date) =>
                                      setPolicyItemRequirement({
                                        ...policyItemRequirement,
                                        [element.id]: date,
                                      })
                                    }
                                    isClearable
                                  />
                                )
                              ) : (
                                <DatePicker
                                  id={element.id}
                                  className="form-control"
                                  showPopperArrow={false}
                                  selected={
                                    policyItemRequirement?.[element.id] &&
                                    new Date(
                                      policyItemRequirement?.[element.id]
                                    )
                                  }
                                  dateFormat="dd/MM/yyyy"
                                  onChange={(date) =>
                                    setPolicyItemRequirement({
                                      ...policyItemRequirement,
                                      [element.id]: date,
                                    })
                                  }
                                  isClearable
                                />
                              )
                            ) : element.type === "select" ? (
                              <Select
                                id={element.id}
                                options={
                                  element?.options
                                    ? element?.options
                                        .split(",")
                                        .map((option) => {
                                          return option.charAt(0) === "*"
                                            ? {
                                                value: option.slice(1),
                                                label: option.slice(1),
                                              }
                                            : { value: option, label: option };
                                        })
                                    : []
                                }
                                onChange={(selectedOption) =>
                                  setPolicyItemRequirement({
                                    ...policyItemRequirement,
                                    [element.id]: selectedOption,
                                  })
                                }
                                value={
                                  policyItemRequirement[element.id]
                                    ? policyItemRequirement[element.id]
                                    : defaultOption
                                }
                              />
                            ) : element.type === "number" ? (
                              <>
                                <InputGroup className="mb-3">
                                  <Form.Control
                                    aria-label="Number (to the nearest value)"
                                    type="number"
                                    min={0}
                                    id={element.id}
                                    onChange={(e) =>
                                      setPolicyItemRequirement({
                                        ...policyItemRequirement,
                                        [element.id]: e.target.value,
                                      })
                                    }
                                    value={
                                      policyItemRequirement[element.id]
                                        ? policyItemRequirement[element.id]
                                        : ""
                                    }
                                  />
                                  <InputGroup.Text className="fw-bold">
                                    {Number.parseFloat(
                                      policyItemRequirement[element.id]
                                    ).toLocaleString("en-US")}
                                  </InputGroup.Text>
                                </InputGroup>
                              </>
                            ) : element.type === "table" ? (
                              <TableWidget
                                id={element.id}
                                data={element}
                                onChange={(value) =>
                                  setPolicyItemRequirement({
                                    ...policyItemRequirement,
                                    [element.id]: JSON.stringify(value),
                                  })
                                }
                                value={
                                  policyItemRequirement[element.id]
                                    ? policyItemRequirement[element.id]
                                    : ""
                                }
                              />
                            ) : element.type === "file" ? (
                              <FileWidget
                                id={element.id}
                                data={element}
                                onChange={(value) =>
                                  setPolicyItemRequirement({
                                    ...policyItemRequirement,
                                    [element.id]: value,
                                  })
                                }
                                // onUploadedFileRemove={handleRemoveUploadedFile}
                                value={
                                  policyItemRequirement[element.id]
                                    ? policyItemRequirement[element.id]
                                    : ""
                                }
                              />
                            ) : element.type === "multilinetext" ? (
                              <textarea
                                className="form-control"
                                id={element.id}
                                onChange={(e) =>
                                  setPolicyItemRequirement({
                                    ...policyItemRequirement,
                                    [element.id]: e.target.value,
                                  })
                                }
                                value={
                                  policyItemRequirement[element.id]
                                    ? policyItemRequirement[element.id]
                                    : ""
                                }
                                rows={5}
                              />
                            ) : ["multi", "multiline"].includes(
                                element?.options?.toLowerCase()
                              ) ? (
                              <textarea
                                className="form-control"
                                id={element.id}
                                onChange={(e) =>
                                  setPolicyItemRequirement({
                                    ...policyItemRequirement,
                                    [element.id]: e.target.value,
                                  })
                                }
                                value={
                                  policyItemRequirement[element.id]
                                    ? policyItemRequirement[element.id]
                                    : ""
                                }
                                rows={5}
                              />
                            ) : (
                              <input
                                className="form-control"
                                id={element.id}
                                onChange={(e) =>
                                  setPolicyItemRequirement({
                                    ...policyItemRequirement,
                                    [element.id]: e.target.value,
                                  })
                                }
                                value={
                                  policyItemRequirement[element.id]
                                    ? policyItemRequirement[element.id]
                                    : ""
                                }
                              />
                            )}
                          </div>
                        </>
                      )}
                    </div>
                  );
                })}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleClose}>
              Close
            </Button>
            {showButton && (
              <Button variant="primary" type="submit">
                Add
              </Button>
            )}
          </Modal.Footer>
        </form>
      </Modal>
    </>
  );
};

export default AddPolicyItem;
